module.exports = __webpack_public_path__ + "fonts/ProximaNovaACond-Black.f12c9fcb27a358b7b0526dfe895e9cc1.woff2";